export default __webpack_public_path__ + "static/assets/9d352e96823fa81f2f76c5b5eea90950.gif";